'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Find if certain value is true in the object
 * @param obj
 * @param predicate     (object, index) => true|false
 * @returns {boolean}
 */
var findDeep = function findDeep(obj, predicate) {
    if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' || obj === null || obj === undefined) {
        return false;
    }

    var allChildren = Object.keys(obj).map(function (k) {
        return obj[k];
    });
    var childrenMeetPredicate = allChildren.map(function (child, k) {
        return predicate(child, k);
    });
    if (childrenMeetPredicate.indexOf(true) > -1) {
        return true;
    }
    var childrenResult = allChildren.map(function (child) {
        return findDeep(child, predicate);
    });
    return childrenResult.indexOf(true) > -1;
};

exports.default = findDeep;


//////////////////
// WEBPACK FOOTER
// ./node_modules/binary-utils/lib/object/findDeep.js
// module id = 375
// module chunks = 0